import { API_BASE_URL } from "@/config";
import { BaseService } from "@/services/base-service";
import { mapReplacementOptions } from "./device-options.mapper";
import type { DeviceOptions } from "./device-options.types";
import type { DeviceOptionsService } from "./device-options-service";

export class HttpDeviceOptionsService extends BaseService implements DeviceOptionsService {
  constructor() {
    super(API_BASE_URL);
  }

  public async getOptions(params: { assetId: string; category: string }): Promise<DeviceOptions> {
    const category = encodeURIComponent(params.category);
    const response = await this.fetch(`/hss/replacement-options?category=${category}`);
    if (!response.ok) {
      throw new Error(`Replacement options API error: ${response.status}`);
    }
    return mapReplacementOptions(await response.json());
  }
}
